import { Paper, Box, Typography, Grid, IconButton, TextField, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { Controller } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Edit } from '@mui/icons-material';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import * as React from 'react';
import SimpleCollapse from '../../../component/MuiReusableComponents/MuiCollapse/collapseMUI';
import { useDispatch, useSelector } from 'react-redux';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import { FormProvider, useForm } from 'react-hook-form';
import MyButton from '../../../component/MuiReusableComponents/MuiButton/buttonMUI';
import FormHead from '../../../component/MuiReusableComponents/FormHeadText/formHeadText';
import MySelect from '../../../component/MuiReusableComponents/MuiFormComponents/Select.component';
import {
    allExpensesSelector,
    allExpenseSelfDataSelector,
    startExpenseRestore,
    startExpenseDataByPagination,
    startSelfExpenseList,
    startSelfExpenseFilteredList,
    startDeleteExpense,
    startSingleExpense,
    startFilteredExpenseData,
    setPage,
    setRowsPerPage
} from '../../../store1/expense data/expenseData.slice.selector';

import MaterialUIPickers from '../../../component/MuiReusableComponents/MuiFormComponents/DatePicker/date.picker.component';

import {
    startEmployeesDataFetch,
    allEmployeesDataSelector,
    isLoadingSelector as isLoadingEmployeeSelector
} from '../../../store1/employees data/employeesData.slice.selector';
import { usersDataSelector } from '../../../store1/user login data/user.login.data.slice.slector';
import PopupDialogs from '../../../component/MuiReusableComponents/MuiPopupDialog/new-popup';
import { useLocation } from 'react-router-dom';
import FilterAndAddBar from '../../../component/ModulesAddAndFilter/moduleAddAndFilter';
import DeletePopup from '../../../component/DeletePopup/deletePopup';
import { sendDateFormateReadStringToSendStrinf, readStringDate } from '../../../function utils/functionUtils';
import { FilterDataSelector, startFilterData } from '../../../store1/client data/client.data.slice.selector';
import Autocomplete from '@mui/material/Autocomplete';
import ExpenseTable from './customExpenseTable';
import { Downloading } from '@mui/icons-material';
import { hasPermission } from '../../../store1/user login data/user.login.data.slice.slector';
import { PERMISSIONS } from '../../../routes/permissionsCode';

const FilterAndSearchBox = ({ infoData }) => {
    const { setCollapseFilterControl, filterStatus, setFilterStatus, filteredRows, setFilteredRows, rows, allEmployeesData } = infoData;
    const [checkedCompany, setCheckedCompany] = React.useState(true);

    const location = useLocation();
    const path = location.pathname || '';
    const existingPath = path.endsWith('my-expenses');

    const form = useForm({
        defaultValues: {
            startDateValue: null,
            endDateValue: null,
            status: '',
            expense_type: 'all',
            employeeNameEmployee_id: '0',
            paymentByCompany: false
        }
    });

    const dispatch = useDispatch();

    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const startDateValue = form.watch('startDateValue');
    const endDateValue = form.watch('endDateValue');

    React.useEffect(() => {
        if (!filterStatus) {
            form.reset({
                startDateValue: null,
                endDateValue: null,
                status: '',
                expense_type: 'all',
                employeeNameEmployee_id: '0',
                paymentByCompany: false
            });
            setCheckedCompany(true);
        }
    }, [filterStatus, form]);

    const onSubmit = (data) => {
        setIsSubmitting(true);

        if (existingPath) {
            const payload = {
                approval_status: data.status || '',
                date_from: data.startDateValue || '',
                date_to: data.endDateValue || ''
            };

            dispatch(startSelfExpenseFilteredList(payload));
            setIsSubmitting(false);
            return;
        }
        const sendDateFormat = (date) => {
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        const mappedData = {
            payment_by: data.expense_type === 'company' ? 'Company' : data.expense_type === 'employee' ? 'Employee' : 'All',
            employee_id: data.employeeNameEmployee_id,
            expense_status: data.status || 2,
            startDateValue: data.startDateValue ? sendDateFormat(data?.startDateValue) : '',
            endDateValue: data.endDateValue ? sendDateFormat(data?.endDateValue) : ''
        };

        dispatch(startFilteredExpenseData(mappedData));
        dispatch(startFilterData(mappedData));

        setIsSubmitting(false);
    };

    const statusArray = [
        // { name: 'All', value: '2' },
        { name: 'Approved', value: '1' },
        { name: 'Pending', value: '0' },
        { name: 'Rejected', value: '-1' }
    ];

    const expenseTypeArray = [
        { name: 'All', value: 'all' },
        { name: 'Employee', value: 'employee' },
        { name: 'Company', value: 'company' }
    ];

    const employeeArray = [...allEmployeesData]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((item) => ({
            name: item.name,
            value: String(item.id)
        }));
    const employeeArray2 = [{ name: 'All', value: '0' }, ...employeeArray];

    const handleResetButton = () => {
        form.reset({
            startDateValue: null,
            endDateValue: null,
            status: '',
            expense_type: 'all',
            employeeNameEmployee_id: '0',
            paymentByCompany: false
        });
        setFilterStatus(false);
        setFilteredRows(rows);
        setCheckedCompany(true);

        dispatch(
            startFilterData({
                payment_by: 'All',
                employee_id: '0',
                expense_status: '2',
                startDateValue: null,
                endDateValue: null
            })
        );
        dispatch(setPage(1));
        dispatch(setRowsPerPage(10));

        if (!existingPath) {
            dispatch(startExpenseDataByPagination());
        } else {
            dispatch(startSelfExpenseList());
        }
    };

    const downloadExcelReport = () => {
        try {
            let sourceData;

            if (filteredRows && Array.isArray(filteredRows)) {
                sourceData = Array.isArray(filteredRows[0]) ? filteredRows[0] : filteredRows;
            } else if (rows) {
                sourceData = Array.isArray(rows[0]) ? rows[0] : rows;
            }

            if (!sourceData || sourceData.length === 0) {
                alert('No data available to download');
                return;
            }

            const formattedData = sourceData.map((row, index) => ({
                'S.No.': index + 1,
                'Expense Type': row.expense_type || '',
                'Expense Description': row.expense_description || '',
                'Expense Date': row.expense_date ? readStringDate(row.expense_date) : '',
                'Payment By': row.payment_by || '',
                'Amount (INR)': parseFloat(row.amount || row.total_amount_round || 0).toFixed(2),
                'Approval Status': row.approval_status === 1 ? 'Approved' : row.approval_status === -1 ? 'Rejected' : 'Pending',
                'Approval Date': row.approval_date ? readStringDate(row.approval_date) : ''
            }));

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(formattedData);

            worksheet['!cols'] = [
                { wch: 6 }, // S.No
                { wch: 20 }, // Type
                { wch: 30 }, // Description
                { wch: 15 }, // Date
                { wch: 20 }, // Payment By
                { wch: 15 }, // Amount
                { wch: 15 }, // Status
                { wch: 15 } // Approval Date
            ];

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Expense Report');

            const excelBuffer = XLSX.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            const blobData = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            const filename = `Expense_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
            saveAs(blobData, filename);
        } catch (error) {
            alert('Error generating report. Please try again.');
        }
    };
    const expenseType = form.watch('expense_type');

    React.useEffect(() => {
        if (expenseType === 'employee') {
            setCheckedCompany(false);
        } else {
            setCheckedCompany(true);
            form.setValue('employeeNameEmployee_id', '0');
        }
    }, [expenseType]);

    return (
        <Paper sx={{ borderRadius: '10px', marginBottom: '15px', bgcolor: '#dff9fb87' }}>
            <Box
                sx={{
                    textAlign: 'right',
                    display: 'flex',
                    flexDirection: 'row',
                    paddingTop: '10px',
                    bgcolor: '#ffeaa786'
                }}
            >
                <Typography
                    sx={{
                        width: '100%',
                        textAlign: 'left',
                        fontWeight: 'bold',
                        paddingLeft: '25px'
                    }}
                    variant="subtitle1"
                    gutterBottom
                >
                    Filter
                </Typography>
            </Box>
            <FormProvider {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)}>
                    <Grid sx={{ pl: 2, mt: 2 }} container rowSpacing={1} columnSpacing={2} className="parent-grid">
                        {/* Payment By */}
                        {!existingPath && (
                            <Grid item xs={12} sm={4} md={2}>
                                <Box className="box-parent">
                                    <FormHead headText="Payment By" />
                                    <MySelect
                                        sx={{ width: '100%' }}
                                        fullWidth
                                        size="small"
                                        name="expense_type"
                                        items={[...expenseTypeArray]}
                                    />
                                </Box>
                            </Grid>
                        )}

                        {/* Employee */}
                        {!existingPath && (
                            <Grid item xs={12} sm={4} md={2}>
                                <Box className="box-parent">
                                    <FormHead headText="Employee" />
                                    <MySelect
                                        sx={{ width: '100%' }}
                                        fullWidth
                                        size="small"
                                        disabled={checkedCompany}
                                        name="employeeNameEmployee_id"
                                        items={[...employeeArray2]}
                                    />
                                </Box>
                            </Grid>
                        )}

                        {/* Status */}
                        <Grid item xs={12} sm={4} md={2}>
                            <Box className="box-parent">
                                <FormHead headText="Status" />
                                <MySelect sx={{ width: '100%' }} fullWidth size="small" name="status" items={[...statusArray]} />
                            </Box>
                        </Grid>

                        {/* Start Date */}
                        <Grid item xs={12} sm={6} md={2}>
                            <Box className="box-parent">
                                <FormHead headText="Start Date" />
                                <Controller
                                    name="startDateValue"
                                    control={form.control}
                                    render={({ field, fieldState: { error } }) => (
                                        <MaterialUIPickers
                                            {...field}
                                            size="small"
                                            views={['year', 'month', 'day']}
                                            maxDate={endDateValue || undefined}
                                            error={!!error}
                                            helperText={error?.message}
                                            fullWidth
                                        />
                                    )}
                                />
                            </Box>
                        </Grid>

                        {/* End Date */}
                        <Grid item xs={12} sm={6} md={2}>
                            <Box className="box-parent">
                                <FormHead headText="End Date" />
                                <Controller
                                    name="endDateValue"
                                    control={form.control}
                                    render={({ field, fieldState: { error } }) => (
                                        <MaterialUIPickers
                                            {...field}
                                            size="small"
                                            views={['year', 'month', 'day']}
                                            minDate={startDateValue || undefined}
                                            error={!!error}
                                            helperText={error?.message}
                                            fullWidth
                                        />
                                    )}
                                />
                            </Box>
                        </Grid>
                    </Grid>

                    {/* Buttons */}
                    <Box
                        sx={{
                            mt: 3,
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '10px'
                        }}
                    >
                        <MyButton size="small" variant="contained" type="submit" startIcon={<SearchIcon />} disabled={isSubmitting}>
                            Search
                        </MyButton>

                        <MyButton size="small" color="error" variant="contained" onClick={handleResetButton}>
                            Reset
                        </MyButton>

                        <MyButton
                            variant="outlined"
                            size="small"
                            onClick={() => setCollapseFilterControl(false)}
                            startIcon={<CancelPresentationIcon color="error" />}
                        >
                            Close
                        </MyButton>

                        <MyButton variant="outlined" size="small" onClick={downloadExcelReport} startIcon={<Downloading />}>
                            Download Report
                        </MyButton>
                    </Box>
                </form>
            </FormProvider>
        </Paper>
    );
};

////Restore
const ExpenseReasonForm = ({ row, setPopUpBool, pageIndex, pageSize }) => {
    const dispatch = useDispatch();
    const [remarkReason, setRemarkReason] = React.useState('');
    //
    const userLoginData = useSelector(usersDataSelector);

    //
    const {
        id,
        expense_id,
        expense_description,
        expense_date,
        document_path,
        payment_status,
        payment_date,
        payment_by,
        payment_method,
        remarks,
        status,
        added_by,
        amount,
        employee_id,
        approval_date,
        billNo,
        vendor_id,
        vendor_name
    } = row;
    const reasonChangeHandler = (event) => {
        setRemarkReason(event.target.value);
    };
    const onSubmitHandler = () => {
        if (remarkReason.trim() === '') {
            return;
        }
        setPopUpBool(false);
        dispatch(
            startExpenseRestore({
                changeRemarkData: {
                    type_id: row?.id,
                    type: 'EXPENSE',
                    user_name: userLoginData.userName,
                    user_email: userLoginData.userEmail,
                    remarks: remarkReason,
                    previous_data: JSON.stringify(row)
                },
                updateData: {
                    id,
                    expense_type: expense_id,
                    expense_description,
                    expense_date: sendDateFormateReadStringToSendStrinf(expense_date),
                    document_path,
                    payment_status,
                    payment_date: sendDateFormateReadStringToSendStrinf(payment_date),
                    payment_by,
                    payment_method,
                    remarks,
                    status,
                    added_by,
                    amount,
                    employee_id,
                    approval_status: 0,
                    forced_change: -1,
                    approval_date: sendDateFormateReadStringToSendStrinf(approval_date),
                    billNo,
                    url: 'expense/add',
                    vendor_id,
                    vendor_name
                },
                tableData: {
                    pageIndex: Number(pageIndex) + 1,
                    pageSize
                }
            })
        );
    };

    return (
        <>
            <Box>
                <Grid container sx={{ p: '20px' }} columnSpacing={1}>
                    <Grid item xs={12}>
                        <TableContainer sx={{ marginBottom: '17px' }}>
                            <Table>
                                <TableBody>
                                    <TableRow
                                        sx={{
                                            borderTop: '2px solid black',
                                            borderLeft: '2px solid black',
                                            borderRight: '2px solid black'
                                        }}
                                    >
                                        <TableCell sx={{ borderRight: '2px solid black', padding: '5px' }}>Current Date:</TableCell>
                                        <TableCell sx={{ padding: '5px' }}>{readStringDate(new Date().toDateString())}</TableCell>
                                    </TableRow>
                                    <TableRow
                                        sx={{
                                            marginBottom: '10px',
                                            border: '2px solid black'
                                        }}
                                    >
                                        <TableCell sx={{ borderRight: '2px solid black', padding: '5px' }}>User Name:</TableCell>
                                        <TableCell sx={{ padding: '5px' }}>{userLoginData.userName}</TableCell>
                                    </TableRow>
                                    <TableRow
                                        sx={{
                                            marginBottom: '10px',
                                            border: '2px solid black'
                                        }}
                                    >
                                        <TableCell sx={{ borderRight: '2px solid black', padding: '5px' }}>User Email:</TableCell>
                                        <TableCell sx={{ padding: '5px' }}>{userLoginData.userEmail}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Divider sx={{ marginY: '20px' }} />

                        <Grid item xs={12} sm={12}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                                <FormHead
                                    sx={{ whiteSpace: 'nowrap', paddingTop: '15px', color: 'black' }}
                                    headText={`Reason `}
                                    required={true}
                                />

                                <TextField
                                    onChange={reasonChangeHandler}
                                    value={remarkReason}
                                    placeholder="Reason is required"
                                    multiline={true}
                                    rows={3}
                                    fullWidth // Takes full width
                                    sx={{ marginTop: '5px' }} // Adjust top margin as needed
                                />
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Box sx={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
                            <MyButton
                                type="submit"
                                startIcon={<WarningAmberIcon color="error" />}
                                size="small"
                                variant="contained"
                                color="success"
                                onClick={onSubmitHandler}
                                sx={{ width: '100%' }}
                                disabled={remarkReason.trim() === '' || remarkReason.length < 5}
                            >
                                Confirm
                            </MyButton>
                            <MyButton
                                type="close"
                                startIcon={<CloseIcon color="error" />}
                                size="small"
                                variant="outlined"
                                color="error"
                                onClick={setPopUpBool}
                                sx={{ width: '100%' }}
                            >
                                Close
                            </MyButton>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

//Action Column
const ActionColumn = ({ row, pageIndex, pageSize }) => {
    const canViewExpense = useSelector((state) => hasPermission(state, PERMISSIONS.EXPENSES.EXPENSE.VIEW_SELF));
    const hasAdminPermission = useSelector((state) => hasPermission(state, PERMISSIONS.EXPENSES.EXPENSE.ADMIN_SUBMIT));
    const locationName = useLocation().pathname;
    const existingPath = locationName.endsWith('my-expenses');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [popupOpen2, setPopUpOpen2] = React.useState(false);
    const [popUpOpen, setPopUpOpen] = React.useState(false);

    function setClosePopup() {
        setPopUpOpen2(false);
        setPopUpOpen(false);
    }
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-evenly'
            }}
        >
            <IconButton
                disabled={!canViewExpense}
                title="View Details"
                size="small"
                onClick={() => {
                    navigate(`${locationName}/${row.id}/view-expense`);
                }}
            >
                <VisibilityIcon color="primary" />
            </IconButton>

            <IconButton
                disabled={row.approval_status === 1 || row.approval_status === -1}
                title="Edit Expense"
                size="small"
                onClick={() => {
                    dispatch(startSingleExpense(row.id));
                    navigate(`${locationName}/${row.id}/edit`);
                }}
            >
                <Edit color={row.approval_status === 1 || row.approval_status === -1 ? undefined : 'primary'} />
            </IconButton>

            {!(row.approval_status === 1 || row.approval_status === -1) ? (
                <IconButton
                    disabled={!hasAdminPermission && row.status === 0}
                    aria-label="delete"
                    title="Delete Expense"
                    onClick={() => {
                        setPopUpOpen(true);
                    }}
                >
                    <DeleteIcon color={row.status === 1 ? 'error' : undefined} />
                </IconButton>
            ) : (
                <IconButton disabled title="Disabled" size="small">
                    <DeleteIcon />
                </IconButton>
            )}

            <PopupDialogs title={'API'} needTitleBar={false} size="sm" open={popUpOpen || popupOpen2} setOpen={setClosePopup}>
                {popUpOpen && (
                    <DeletePopup
                        onClickNo={() => setPopUpOpen(false)}
                        onClickYes={() => {
                            dispatch(
                                startDeleteExpense({
                                    data: row.id,
                                    tableData: { pageIndex: Number(pageIndex) + 1, pageSize, existingPath }
                                })
                            );
                        }}
                    />
                )}

                {popupOpen2 && <ExpenseReasonForm row={row} setPopUpBool={setClosePopup} pageIndex={pageIndex} pageSize={pageSize} />}
            </PopupDialogs>
        </Box>
    );
};

const ExpensesManagmentData = ({ isLoadingExpenses, pageIndex, pageSize, setPageIndex, setPageSize }) => {
    const hasAdminPermission = useSelector((state) => hasPermission(state, PERMISSIONS.EXPENSES.EXPENSE.ADMIN_SUBMIT));
    const location = useLocation();
    const path = location.pathname || '';
    const existingPath = path.endsWith('my-expenses');
    const [collapseFilterControl, setCollapseFilterControl] = React.useState(false);
    const dispatch = useDispatch();
    const isLoadingEmploye = useSelector(isLoadingEmployeeSelector);
    const allEmployeesData = useSelector(allEmployeesDataSelector);
    const allExpenses = useSelector(!existingPath ? allExpensesSelector : allExpenseSelfDataSelector);
    const [data, setData] = React.useState([]);
    const [rowsCount, setRowsCount] = React.useState(0);

    const fildata = useSelector(FilterDataSelector);
    const fecthDataDispatch = () => {
        if (fildata.employee_id || fildata.payment_by || fildata.expense_status || fildata.startDateValue) {
            const mapobj = {
                payment_by: fildata.payment_by,
                employee_id: fildata.employee_id,
                expense_status: fildata.expense_status,
                startDateValue: fildata.startDateValue,
                endDateValue: fildata.endDateValue
            };
            dispatch(startFilteredExpenseData(mapobj));
        } else {
            dispatch(startExpenseDataByPagination());
        }
    };

    React.useEffect(() => {
        if (allExpenses && allExpenses.length > 0) {
            setFilteredRows(allExpenses[0]);
        }
        if (!existingPath) {
            setData(allExpenses[0]);
            setRowsCount(allExpenses?.[1]?.[0].total_count);
        } else {
            setData(allExpenses);
            setRowsCount(allExpenses.length);
        }
    }, [allExpenses]);

    React.useEffect(() => {
        if (!existingPath) {
            dispatch(startExpenseDataByPagination());
        } else {
            dispatch(startSelfExpenseList());
        }
    }, [pageIndex, pageSize]);

    React.useEffect(() => {
        if (hasAdminPermission === true) {
            dispatch(startEmployeesDataFetch());
        }
    }, []);

    //
    const [filterStatus, setFilterStatus] = React.useState(false);
    const [filteredRows, setFilteredRows] = React.useState([]);
    //
    const locationName = useLocation().pathname;
    const headCells =
        locationName === '/expense-management/pending-expenses-management'
            ? [
                  {
                      id: 'id',
                      numeric: false,
                      disablePadding: false,
                      label: 'S No.'
                  },
                  {
                      id: 'expense_type',
                      numeric: false,
                      disablePadding: false,
                      label: 'Expense Type'
                  },
                  {
                      id: 'expense_description',
                      numeric: false,
                      disablePadding: false,
                      label: 'Expense Description '
                  },
                  {
                      id: 'expense_date',
                      numeric: false,
                      disablePadding: false,
                      label: 'Expense Date',
                      align: 'center'
                  },
                  {
                      id: 'payment_by',
                      numeric: false,
                      disablePadding: false,
                      label: 'Payment By'
                  },
                  {
                      id: 'total_amount',
                      numeric: false,
                      disablePadding: false,
                      label: 'Amount (INR)',
                      align: 'center'
                  },

                  {
                      id: 'approval_status',
                      numeric: false,
                      disablePadding: false,
                      label: 'Approval Status',
                      align: 'right'
                  },
                  {
                      id: 'action',
                      numeric: false,
                      disablePadding: false,
                      label: 'Action'
                  }
              ]
            : [
                  {
                      id: 'id',
                      numeric: false,
                      disablePadding: false,
                      label: 'S No.'
                  },
                  {
                      id: 'expense_type',
                      numeric: false,
                      disablePadding: false,
                      label: 'Expense Type'
                  },
                  {
                      id: 'expense_date',
                      numeric: false,
                      disablePadding: false,
                      label: 'Expense Date',
                      align: 'center'
                  },
                  {
                      id: 'payment_by',
                      numeric: false,
                      disablePadding: false,
                      label: 'Payment By'
                  },
                  {
                      id: 'total_amount',
                      numeric: false,
                      disablePadding: false,
                      label: 'Amount (INR)',
                      align: 'right'
                  },

                  {
                      id: 'approval_status',
                      numeric: false,
                      disablePadding: false,
                      label: 'Approval Status',
                      align: 'right'
                  },
                  {
                      id: 'approval_date',
                      numeric: false,
                      disablePadding: false,
                      label: 'Approval Date',
                      align: 'center'
                  },
                  {
                      id: 'action',
                      numeric: false,
                      disablePadding: false,
                      label: 'Action',
                      align: 'center'
                  }
              ];

    const navigate = useNavigate();
    const canCreateExpense = useSelector((state) => hasPermission(state, PERMISSIONS.EXPENSES.EXPENSE.SUBMIT));
    const userData = useSelector(usersDataSelector);
    const onclickFilter = () => setCollapseFilterControl(!collapseFilterControl);
    const onClickAdd = () => {
        existingPath
            ? navigate('/dashboard/my-expenses/add-expense')
            : navigate('/manage-accounts/expense-management/expenses-list/add-expense');
    };
    return (
        <Box>
            <FilterAndAddBar
                onclickFilter={onclickFilter}
                onClickAdd={onClickAdd}
                filterStatus={filterStatus}
                setCollapseFilterControl={setCollapseFilterControl}
                collapseFilterControl={collapseFilterControl}
                filterName=" Filter"
                showFilterName={canCreateExpense || userData.empId !== null}
                AddButtonName=" + Add New Expense"
                showAddButton={canCreateExpense || userData.empId !== null}
            />
            <SimpleCollapse
                infoData={{
                    setCollapseFilterControl,
                    allEmployeesData,
                    setFilteredRows,
                    setFilterStatus,
                    filterStatus,
                    rows: allExpenses
                }}
                control={collapseFilterControl}
                CollapseComponent={FilterAndSearchBox}
            />
            <Box>
                <ExpenseTable
                    headCells={headCells}
                    isLoading={isLoadingExpenses || isLoadingEmploye}
                    loadingMessage={'Loading Please wait'}
                    ActionComponent={ActionColumn}
                    data={data}
                    dispatchAPI={fecthDataDispatch}
                    rowsCount={rowsCount}
                    setRowsCount={setRowsCount}
                    pathName={locationName}
                    pageSize={pageSize}
                    pageIndex={pageIndex}
                    setPageSize={setPageSize}
                    setPageIndex={setPageIndex}
                />
            </Box>
        </Box>
    );
};
export default ExpensesManagmentData;
